<div class="datepicker-v2-input" [formGroup]="parentForm" [class.white-bg]="whiteBg">
  <mat-form-field appearance="fill">
    <input matInput [matDatepicker]="picker" [formControlName]="controlName" [placeholder]="placeholder"
      [min]="min" [max]="max" (blur)="handleTouched()">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [startView]="startView" (closed)="handleTouched()"></mat-datepicker>
  </mat-form-field>
</div>
